import type { RouteRecordRaw } from 'vue-router'

import type { RedirectRouteRelative } from '@/utilities/routers'

import {
  routeItemPricesHome,
  routeItemPricesRoot,
} from '@/routers/routes/mainRoutes/routeServices/routePrices/itemPricesRoutes.ts'
import { routePriceListsRoot } from '@/routers/routes/mainRoutes/routeServices/routePrices/priceListRoutes.ts'
import { routePricingRulesRoot } from '@/routers/routes/mainRoutes/routeServices/routePrices/pricingRuleRoutes.ts'

const routePricesHome: RouteRecordRaw = {
  name: 'prices-home',
  path: '',
  redirect: routeItemPricesHome,
}

const routePricesRoot: RouteRecordRaw = {
  children: [routePricesHome, routeItemPricesRoot, routePricingRulesRoot, routePriceListsRoot],

  path: 'prices',
}

const redirectPrices: RedirectRouteRelative = {
  name: routePricesHome.name,
}

export { redirectPrices, routePricesHome, routePricesRoot }
